




















import { Component, Emit, Prop, Watch, Vue } from "vue-property-decorator";

@Component<EditNameDialog>({
  data() {
    return {
      internalInputValue: this.inputValue
    };
  }
})
export default class EditNameDialog extends Vue {
  @Prop({ required: true })
  isDisplayDialog!: boolean;

  @Prop()
  inputValue?: string;

  internalInputValue!: string;

  @Watch("inputValue")
  onInputValueChange(inputValue: string) {
    this.internalInputValue = inputValue;
  }

  @Emit()
  hidePrompt() {
    return !this.isDisplayDialog;
  }

  @Emit()
  submit() {
    return this.internalInputValue;
  }
}
